import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import LanguageContent from './LanguageContent'
export default class Dashboard extends React.Component {

   
    
    render() {
        let id = this.props.match.params.id;
       
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <LanguageContent id={id} />
                <Footer /> 

            </div>


        )
    }
}
